function main() {
    const video = document.getElementById("home-hero__video");
    const playPauseButton = document.getElementById("home-hero__play-button");
    const pauseButtonInnerHtml = `<span class="sr-only">Pause Button</span><svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="21" cy="21" r="20" stroke="white" stroke-width="2"/>
                <rect x="15" y="14" width="4" height="14" fill="white"/>
                <rect x="23" y="14" width="4" height="14" fill="white"/>
                </svg>`
    const playButtonInnerHtml = `<span class="sr-only">Play Button</span><svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M28.6367 21.7567L16.7469 28.9229L16.7469 14.5905L28.6367 21.7567Z" fill="white"/>
                <circle cx="21" cy="21" r="20" stroke="white" stroke-width="2"/>
                </svg>
                `
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)')

    if (video && playPauseButton) {
        // Hide iOS default video controls
        video.controls = false;

        // Set default button state
        playPauseButton.innerHTML = pauseButtonInnerHtml;

        // If user prefers reduced motion, pause the video
        if (prefersReducedMotion.matches) {
            video.pause();
            playPauseButton.innerHTML = playButtonInnerHtml;
        }

        playPauseButton.addEventListener('click', (e) => {
            e.preventDefault();
            if (video.paused) {
                video.play();
                playPauseButton.innerHTML = pauseButtonInnerHtml;
            } else {
                video.pause();
                playPauseButton.innerHTML = playButtonInnerHtml;
            }
        });
    }
}

export default function () {
    main();
}
